<template>
  <div id="app">
    <div class="container">
      <router-view />
      <div class="nav">
        <router-link to="/" tag="div">Profile</router-link>
        <div>Work</div>
        <div>Contact</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style lang="scss">


$breakpoints_threshold_minus1: 767px;
$breakpoints_threshold: 768px;

$desired-height: 480px;
$desired-width: 768px;

html, body {
  margin: 0;
  padding: 0;
}

* {
  box-sizing: border-box;
}

#app {
  height: 100vh;
  width: 100vw;
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: #262626;

  display: flex;
  justify-content: center;
  align-items: center;

  user-select: none;

  .container {
    @media only screen and (max-width: $breakpoints_threshold_minus1) {
      height: 100%;
      width: 100%;
    }
    @media only screen and (min-width: $breakpoints_threshold) {
      height: $desired-height;
      width: $desired-width;
    }
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
	  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.25);
    background-color: #404040;
    color: #CCCCCC;
  }

  .nav {

    @media only screen and (max-width: $breakpoints_threshold_minus1) {
      display: none;
    }
    @media only screen and (min-width: $breakpoints_threshold) {
      display: flex;
      justify-content: space-around;
      align-items: center;    
      padding: 0 20%;
    }
    
    > div {
      
      display: inline-block;
      height: $desired-height * 0.1;
      min-width: 80px;
      box-sizing: border-box;
      line-height: $desired-height * 0.1;

      &.router-link-active {
        border-bottom: 5px solid #CCCCCC;
        bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue